import { render, staticRenderFns } from "./NameSetting.vue?vue&type=template&id=4a29dd09&scoped=true"
import script from "./NameSetting.vue?vue&type=script&lang=js"
export * from "./NameSetting.vue?vue&type=script&lang=js"
import style0 from "./NameSetting.vue?vue&type=style&index=0&id=4a29dd09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a29dd09",
  null
  
)

export default component.exports